var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('relay-graph-key',{attrs:{"stats":_vm.relayKeysStats}})
}
var staticRenderFns = []

export { render, staticRenderFns }